export const SIGN_IN_FAIL = 'SIGN_IN_FAIL';
export const ALLOWED_PATHS_FOR_URL_TOKEN = ['.*order-confirmation/.*'];
